import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import qs from 'qs';

import { compare, siteTypesEnum } from '../../../../helpers';
import { fetchSiteSpeakersAction } from '../../../../store/siteDucks/siteSpeakers';

import SiteLayout from '../../../layouts/SiteLayout/SiteLayout';
import HeadingSection from '../../../siteBaseSections/HeadingSection/HeadingSection';
import FilterableContent from '../../../shared/FilterableContent/FilterableContent';
import SpeakersTable from '../../../sections/SpeakersTable/SpeakersTable';
import { InformaMetaTagPageType } from '../../../../constants';
import { Helmet } from 'react-helmet';

class SpeakersView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sidebarHidden: !props.siteSpeakers.data.openSearchPanel,
    };

    this.fetchSiteSpeakers = this.fetchSiteSpeakers.bind(this);
    this.toggleViewSettings = this.toggleViewSettings.bind(this);
  }

  fetchSiteSpeakers(filters) {
    return this.props.fetchSpeakers(
      qs.stringify(filters, {
        encode: true,
        indices: false,
        addQueryPrefix: true,
      }),
    );
  }

  toggleViewSettings(setting) {
    if (setting === 'sidebarHidden') {
      this.setState((state) => {
        return {
          sidebarHidden: !state.sidebarHidden,
        };
      });
    }
  }

  getPrimaryFilterConfig() {
    const {
      siteSpeakers: {
        data: { streams = [], formats = [], topics = [] } = {},
      } = {},
      t,
    } = this.props;

    const groups = [];

    groups.push({
      name: 'stream',
      title: t('event.agenda.streams'),
      items:
        streams.length === 1 && streams[0].name === 'Main agenda'
          ? []
          : streams
              .sort((a, b) => compare(a.name, b.name))
              .map((item) => ({
                name: item.name,
                filterId: item.filterId.toString(),
                count: item.count,
                color: item.colorIndex,
              })),
    });

    groups.push({
      name: 'format',
      title: t('event.agenda.formats'),
      items: formats
        .sort((a, b) => compare(a.name, b.name))
        .map((item) => ({
          name: item.name,
          count: item.count,
        })),
    });

    groups.push({
      name: 'topic',
      title: t('event.agenda.topics'),
      items: topics
        .sort((a, b) => compare(a.name, b.name))
        .map((item) => ({
          name: item.name,
          count: item.count,
        })),
    });

    return groups.filter((group) => group.items.length > 0);
  }

  render() {
    const {
      siteHeader: {
        meta: { title, description: defaultMetaDescription } = {},
      } = {},
      siteSpeakers: {
        data: {
          title: contentTitle,
          pageTitle,
          titleSize,
          showPageHeader,
          description,
          roleName = '',
        } = {},
        meta: { title: metaTitle, description: metaDescription } = {},
      } = {},
      pageConfig: { siteType } = {},
      t,
    } = this.props;

    const { sidebarHidden } = this.state;
    const { data: { speakers = [] } = {} } = this.props.siteSpeakers;
    const primaryFilterConfig = this.getPrimaryFilterConfig();
    const { COURSE } = siteTypesEnum();
    const personTypeKey =
      siteType === COURSE
        ? `event.${roleName.toLowerCase()}s`
        : 'event.speakers';

    const helmet = {
      title: metaTitle || contentTitle || `${t(personTypeKey)} | ${title}`,
      description: metaDescription || defaultMetaDescription,
    };

    let heading = pageTitle;
    if (!heading) {
      heading =
        siteType === COURSE ? (
          <span>
            {roleName !== 'TRAINER' ? 'Course ' : ''}
            {t(personTypeKey)}
          </span>
        ) : (
          t(personTypeKey)
        );
    }

    return (
      <SiteLayout helmet={helmet}>
        <Helmet>
          <meta name="informa-page-id" content="speakers" />
          <meta
            name="informa-page-type"
            content={InformaMetaTagPageType.BasePage}
          />
        </Helmet>
        {showPageHeader && (
          <HeadingSection
            title={heading}
            titleSize={titleSize}
            text={description}
          />
        )}
        <FilterableContent
          mode="speakers"
          allowSearch
          showTopBar
          primaryFilter={primaryFilterConfig}
          sidebarHidden={sidebarHidden}
          toggleViewSettings={this.toggleViewSettings}
          onUpdate={this.fetchSiteSpeakers}
        >
          <SpeakersTable speakers={speakers} siteType={siteType} />
        </FilterableContent>
      </SiteLayout>
    );
  }
}

SpeakersView.propTypes = {
  siteHeader: PropTypes.object,
  siteSpeakers: PropTypes.object,
  pageConfig: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    siteHeader: state.siteHeader,
    siteSpeakers: state.siteSpeakers,
    pageConfig: state.pageConfig,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchSpeakers(search) {
      return dispatch(fetchSiteSpeakersAction(search));
    },
  };
}

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(SpeakersView)),
);
